var _defs, _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContentSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_1827",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#ffa326}\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_102",
    cx: 1.286,
    cy: 1.286,
    r: 1.286,
    className: "cls-1",
    transform: "translate(8.197 9)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_103",
    cx: 1.286,
    cy: 1.286,
    r: 1.286,
    className: "cls-1",
    transform: "translate(16.232 9)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6687",
    d: "M16.5 30A13.5 13.5 0 1 1 30 16.5 13.5 13.5 0 0 1 16.5 30zm0-25.714A12.214 12.214 0 1 0 28.715 16.5 12.214 12.214 0 0 0 16.5 4.286z",
    className: "cls-1",
    transform: "translate(-3 -3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6688",
    d: "M26.5 30.286H13.643a.643.643 0 1 1 0-1.286H26.5a.643.643 0 1 1 0 1.286z",
    className: "cls-1",
    transform: "translate(-6.571 -12.286)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentSelected);
export default __webpack_public_path__ + "static/media/content-selected.4e2265ec0c5ba2af94499dea77e08f79.svg";
export { ForwardRef as ReactComponent };